export const loginEmailStoreKey: string = `LoginEmail`;
